"use client";
import React, { useState } from 'react';

export const FAQitem = ({question, answer}) =>{

    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return(
        <>
            <div className='p-4 mb-4 border-b border-gray-200'>

                <h3 className='text-lg md:text-xl font-semibold text-[#545454] mb-[18px] cursor-pointer'
                    onClick={toggleOpen}
                    aria-expanded={isOpen}
                >
                    {question}
                    <span className='float-right'>
                        {isOpen ? '-' : '+'}
                    </span>
                </h3>

                {isOpen && (<p onClick={toggleOpen}
                    className='text-lg md:text-l text-[#545454] mb-[18px]'>
                        {answer}
                    </p>
                )}
            </div>
        </>
    )
}

